
export default {
    name: 'RootFolders',
    props: {
        folder: {
            type: Object,
            default: null
        }
    },
    computed: {
        roots () {
            return this.$store.getters['folders/getRootFolders']
        }
    },
    methods: {
        isRootActive (root) {
            return this.$store.getters['folders/getActiveRootFolder']?.id === root?.id
        },
        listRoot (root) {
            if (this.isRootActive(root)) {
                return
            }
            this.$emit('list', root)
        }
    }
}
